import { createFileRoute } from '@tanstack/react-router'
import { ChequeDetailScreen } from '@/features/accounting-cheques/cheque-detail-screen'

/**
 * Route shell for one cheque (WP09). `.index` keeps it a child of
 * `cheques.tsx`, whose guard already ran.
 */
export const Route = createFileRoute('/_authenticated/accounting/cheques/$chequeId/')({
  component: ChequeDetailRoute,
})

function ChequeDetailRoute() {
  const { chequeId } = Route.useParams()

  return <ChequeDetailScreen chequeId={chequeId} />
}
